import React from 'react';

const AuthCard = ({ brand, title, subtitle, children }) => (
  <div className="auth-card">
    <div className="auth-brand">
      <span className="auth-brand-mark">{brand.mark}</span>
      <div className="auth-brand-divider" />
    </div>
    <header className="auth-card-header">
      <h1>{title}</h1>
      {subtitle ? <p>{subtitle}</p> : null}
    </header>
    {children}
  </div>
);

export default AuthCard;
